<template>
  <div
    :class="['organism wysiwyg-block', 'container-' + organism.containerWidth, organism.removeMargin]"
    :style="'background-color:' + organism.backgroundColor"
  >
    <div class="wrapper">
      <div class="text-content" v-html="organism.description"></div>
      <MoleculesButtons
        v-if="organism.button1"
        :buttons="organism"
        :button-colors="[
          organism.button1Color ?? 'button-blue',
          organism.button2Color ?? 'button-white',
          organism.button3Color ?? 'button-white',
        ]"
      />
    </div>
  </div>
</template>

<style>
.organism.wysiwyg-block {
  .text-content {
    h1 {
      @apply mx-auto text-4xl font-semibold sm:text-6xl font-archer text-gray-800;
    }

    h2 {
      @apply text-3xl font-semibold md:text-5xl font-archer text-gray-800;
    }

    h3 {
      @apply text-2xl font-semibold md:text-4xl font-archer text-gray-800;
    }

    h4 {
      @apply text-xl font-semibold md:text-3xl font-archer text-gray-800;
    }

    h5 {
      @apply text-lg font-semibold md:text-2xl font-archer text-gray-800;
    }
  }
}
</style>

<script setup>
const props = defineProps({
  organism: Object,
});

onMounted(() => {
  if (props.organism.containerWidth === "full-width") {
    addFullWidthSupport();
  }
});
</script>
